import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/home.module.css';

const TerminalSection = ({
  title,
  description,
  buttonText,
  buttonLink,
  image,
  imageAlt
}) => {
  return (
    <div
      className={styles.bottom}
      style={{
        backgroundColor: "#8bc34a",
        color: "#fff",
        padding: "20px 20px",
        borderRadius: "35px",
        margin: "40px 70px 65px 50px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1 1 300px", marginBottom: "30px" }}>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            {title}
          </h2>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              marginBottom: "20px",
            }}
          >
            {description}
          </p>
          <div className={styles.contact}>
            <Link to={buttonLink}>
              <button
                style={{
                  backgroundColor: "#fff",
                  color: "green",
                  border: "none",
                  padding: "15px 30px",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {buttonText}
              </button>
            </Link>
          </div>
        </div>
        <div
          style={{
            flex: "1",
            marginBottom: "30px",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <img
            src={image}
            alt={imageAlt}
            style={{
              width: "100%",
              borderRadius: "40px",
              height: "auto",
              display: "block",
              objectFit: "cover",
            }}
          />
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                borderRadius: "5px",
                padding: "5px 10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#8bc34a",
                  marginRight: "5px",
                }}
              />
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#fdd835",
                  marginRight: "5px",
                }}
              />
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#1e88e5",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminalSection;